export const routerMap = {
  operator: {
    Home: 'Home',
    DMEO: 'Demo',
    'DEMO1.1': 'Demo.List',
    'DEMO1.2': 'Demo.Create',
    XO1: 'Account',
    'XO1.1': 'Account.User.List',
    'XO1.1.1': 'Account.User.Create',
    'XO1.1.2': 'Account.User.Edit',
    'XO1.2': 'Account.Role.List',
    'XO1.2.1': 'Account.Role.Create',
    'XO1.2.2': 'Account.Role.Edit',
    XO2: 'AuditOrder',
    'XO2.1': 'AuditOrder.List',
    XO3: 'Division',
    'XO3.1': 'Division.List',
    XO4: 'Department',
    'XO4.1': 'Department.List',
    'XO4.1.1': 'Department.Create',
    'XO4.1.2': 'Department.Edit',
    XO5: 'Section',
    'XO5.1': 'Section.List',
    'XO5.1.1': 'Section.Create',
    'XO5.1.2': 'Section.Edit',
    XO6: 'RecAddress',
    'XO6.1': 'RecAddress.List',
    'XO6.1.1': 'RecAddress.Create',
    'XO6.1.2': 'RecAddress.Edit',
    XO7: 'Order',
    'XO7.1': 'Order.List',
    XO8: 'ReceiveOrder',
    'XO8.1': 'ReceiveOrder.List',
    XO9: 'System',
    'XO9.1': 'System.SystemParam',
    'XO9.2': 'System.ExchangeRate',
    'XO9.3': 'System.ReportEmail',
    'XO9.4': 'System.ExchangeRateLog',
    XO10: 'CheckOrder',
    'XO10.1': 'CheckOrder.List',
    XO11: 'Channel',
    'XO11.1': 'Channel.List',
    // PROD 20201116
    XO12: 'Report',
    'XO12.1': 'Report.AuditPassedReport'
  },
  department: {
    Home: 'Home',
    XD2: 'Order',
    'XD2.1': 'Order.List',
    'XD2.1.1': 'Order.Create',
    'XD2.1.2': 'Order.Resend',
    XD3: 'Report',
    'XD3.1': 'Report.List'
  }
}

export const sideMenuMap = {
  operator: [
    // {
    //   id: 'DEMO',
    //   name: 'DEMO',
    //   icon: 'idcard',
    //   subset: [
    //     {
    //       id: 'DEMO1.1',
    //       name: 'DEMO LIST'
    //     },
    //     {
    //       id: 'DEMO1.2',
    //       name: 'DEMO'
    //     }
    //   ]
    // },
    {
      // 帳號權限管理
      id: 'XO1',
      name: 'i18n_route_XO1',
      icon: 'idcard',
      subset: [
        {
          id: 'XO1.1',
          name: 'i18n_route_XO1_1'
        },
        {
          id: 'XO1.2',
          name: 'i18n_route_XO1_2'
        }
      ]
    },
    {
      // 分口管理
      id: 'XO4',
      name: 'i18n_route_XO4',
      icon: 'deployment-unit',
      subset: [
        {
          id: 'XO4.1',
          name: 'i18n_route_XO4_1'
        }
      ]
    },
    {
      // 組別管理
      id: 'XO3',
      name: 'i18n_route_XO3',
      icon: 'container',
      subset: [
        {
          id: 'XO3.1',
          name: 'i18n_route_XO3_1'
        }
      ]
    },
    {
      // 項目組管理
      id: 'XO5',
      name: 'i18n_route_XO5',
      icon: 'profile',
      subset: [
        {
          id: 'XO5.1',
          name: 'i18n_route_XO5_1'
        }
      ]
    },
    {
      // 收幣地址管理
      id: 'XO6',
      name: 'i18n_route_XO6',
      icon: 'read',
      subset: [
        {
          id: 'XO6.1',
          name: 'i18n_route_XO6_1'
        }
      ]
    },
    {
      // 通道管理
      id: 'XO11',
      name: 'i18n_route_XO11',
      icon: 'profile',
      subset: [
        {
          id: 'XO11.1',
          name: 'i18n_route_XO11_1'
        }
      ]
    },
    {
      // 訂單管理
      id: 'XO7',
      name: 'i18n_route_XO7',
      icon: 'profile',
      subset: [
        {
          id: 'XO7.1',
          name: 'i18n_route_XO7_1'
        }
      ]
    },
    {
      // 實收幣數管理
      id: 'XO8',
      name: 'i18n_route_XO8',
      icon: 'account-book',
      subset: [
        {
          id: 'XO8.1',
          name: 'i18n_route_XO8_1'
        }
      ]
    },
    {
      // 查收管理
      id: 'XO10',
      name: 'i18n_route_XO10',
      icon: 'schedule',
      subset: [
        {
          id: 'XO10.1',
          name: 'i18n_route_XO10_1'
        }
      ]
    },
    {
      // 審計管理
      id: 'XO2',
      name: 'i18n_route_XO2',
      icon: 'audit',
      subset: [
        {
          id: 'XO2.1',
          name: 'i18n_route_XO2_1'
        }
      ]
    },
    // 日報表 PROD 20201116
    {
      id: 'XO12',
      name: 'i18n_route_XO12',
      icon: 'pie-chart',
      subset: [
        {
          id: 'XO12.1',
          name: 'i18n_route_XO12_1'
        }
      ]
    },
    {
      // 系統管理
      id: 'XO9',
      name: 'i18n_route_XO9',
      icon: 'setting',
      subset: [
        {
          id: 'XO9.1',
          name: 'i18n_route_XO9_1'
        },
        {
          id: 'XO9.2',
          name: 'i18n_route_XO9_2'
        },
        {
          id: 'XO9.3',
          name: 'i18n_route_XO9_3'
        },
        {
          id: 'XO9.4',
          name: 'i18n_route_XO9_4'
        }
      ]
    }
  ],
  department: [
    {
      // 訂單管理
      id: 'XD2',
      name: 'i18n_route_XD2',
      icon: 'profile',
      subset: [
        {
          id: 'XD2.1',
          name: 'i18n_route_XD2_1'
        }
      ]
    },
    {
      // 報表管理
      id: 'XD3',
      name: 'i18n_route_XD3',
      icon: 'pie-chart',
      subset: [
        {
          id: 'XD3.1',
          name: 'i18n_route_XD3_1'
        }
      ]
    }
  ]
}
